document.addEventListener('DOMContentLoaded', function () {
    let sumTry = 0;
    let interval = setInterval(() => {
        const s = document.querySelector('.related-products__items');
        sumTry++;
        if(s){   
            var swiper = new Swiper(".related-products__items", {
                slidesPerView: 1.5,
                spaceBetween: 16,
                breakpoints: {
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 12
                    },
                  },
            });
            clearInterval(interval);
        } else if(sumTry > 100){
            clearInterval(interval)
        }
    }, 10)

});